import React from 'react';
import { Section } from '../ui/Section';
import { OfferSelector } from './OfferSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function FinalCTA() {
  return <Section className="bg-slate-900 text-white relative overflow-hidden" data-id="element-80">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-teal-900/40 via-slate-900 to-slate-900" data-id="element-81"></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10 text-center" data-id="element-82">
        <h2 className="text-2xl md:text-5xl font-extrabold mb-4 md:mb-6" data-id="element-83">
          No dejes pasar esta oportunidad
        </h2>
        <p className="text-lg md:text-xl text-slate-300 mb-8 md:mb-10" data-id="element-84">
          Empezá a gestionar tu consultorio como un negocio profesional hoy
          mismo.
        </p>

        <UrgencyBanner data-id="element-85" />
        <OfferSelector theme="dark" data-id="element-86" />
      </div>
    </Section>;
}